import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef, sizes } from '@shared/port-v1.0.0'

type ListItemScheme = {
    title: string
    icon?: {
        name?: string
        color?: string
        size?: number
        radius?: string
        stroke?: number
        iconColor?: string
        iconSize?: number
    }
    subScheme?: ListItemScheme[]  // Рекурсия для вложенных списков
}

export type Props = BaseReactProps & {
	listScheme: ListItemScheme[] 
	type: 'unordered' | 'ordered'
	withPadding: boolean
}

import Comp from '../component'

export default {
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({
				name: 'listScheme',
				displayName: 'Scheme',
				group: 'Params',
				type: 'array',
				tooltip: 'Must be array',
			}),
			getPortDef({
				name: 'withPadding',
				displayName: 'With padding',
				group: 'Params',
				type: 'boolean',
			}),
			getPortDef({
				name: 'center',
				displayName: 'Center',
				group: 'Params',
				type: 'boolean',
			}),
			getPortDef({ name: 'size', displayName: 'Size', group: 'Dimensions', type: sizes, default: 'md' }),
			getPortDef({
				name: 'spacing',
				displayName: 'Spacing',
				group: 'Layout',
				type: [{ value: '0', label: 'none' }, ...sizes],
				default: '0',
			}),
			getPortDef({
				name: 'listStyleType',
				displayName: 'List style type',
				group: 'Params',
				type: [
					{ value: 'none', label: 'none' }, // Отсутствие маркера
					{ value: 'disc', label: 'disc' }, // Закрашенная точка
					{ value: 'circle', label: 'circle' }, // Открытый кружок
					{ value: 'square', label: 'square' }, // Закрашенный квадрат
					{ value: 'decimal', label: 'decimal' },     // Арабские цифры (1, 2, 3, ...)
					{ value: 'decimal-leading-zero', label: 'decimal-leading-zero' }, // Цифры с ведущим нулём (01, 02, 03, ...)
					{ value: 'upper-latin', label: 'upper-latin' }, // Латиница большая (A, B, C, ...)
					{ value: 'lower-latin', label: 'lower-latin' }, // Латиница маленькая (a, b, c, ...)
					{ value: 'upper-roman', label: 'upper-roman' }, // Большие римские цифры (I, II, III, ...)
					{ value: 'lower-roman', label: 'lower-roman' }, // Малые римские цифры (i, ii, iii, ...)
				],
				default: 'disc',
			}),
		],

		outputs: [],
	},
} satisfies ReactNodeDef
